import script from "./MMP_AM_003.vue?vue&type=script&setup=true&lang=js"
export * from "./MMP_AM_003.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__